import styled from "@emotion/styled";
import { CalendarColoredIcon, ForecastedSalesIcon } from "src/assets/icons";
import { BLUE_LIGHT, PRIMARY_BLACK } from "src/constants/colors";
import { formatDateRangeShort, formatNumberForCurrency } from "src/utils";

const Container = styled.div`
  background: linear-gradient(
    157.88deg,
    rgba(255, 233, 204, 1) -65.41%,
    rgb(255, 255, 255) 82.75%
  );
  border: 1px solid ${BLUE_LIGHT};
  box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: space-between;
  padding: 23px 24px;
  flex: 1;
`;

const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const HeaderTitleCell = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const HeaderIcon = styled.div`
  background-color: rgb(255, 255, 255);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  margin-right: 8px;
  width: 40px;
`;

const HeaderTitle = styled.div`
  color: ${PRIMARY_BLACK};
  font-size: 20px;
  font-weight: 500;
`;

const DateRange = styled.div`
  color: rgb(49, 57, 74);
  font-size: 12px;
`;

const MonthForecastRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

//
//

const CellContainer = styled.div`
  flex: 1;
`;
const CellDateRow = styled.div`
  color: rgba(49, 57, 74, 1);
  display: flex;
  align-items: center;
  font-size: 12px;
  gap: 8px;
  margin-bottom: 12px;
`;

const CellAmount = styled.div`
  color: ${PRIMARY_BLACK};
  font-size: 26px;
  font-weight: 500;
  margin-bottom: 15px;

  &::before {
    content: "$";
  }
`;

const UnitsCellContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 34px;
  padding: 0px 7px;
`;
const UnitsCellNumber = styled.div`
  color: ${PRIMARY_BLACK};
  font-size: 14px;
  font-weight: 600;
`;

const UnitsCellLabel = styled.div`
  color: rgba(74, 84, 102, 1);
  font-size: 10px;
`;
export interface ForecastedSalesItem {
  value?: number;
  units?: {
    total?: number;
  };
  time_range?: {
    start?: string;
    end?: string;
  };
}

interface UnitsCellProps {
  count: number;
}

const UnitsCell = ({ count }: UnitsCellProps) => (
  <UnitsCellContainer>
    <UnitsCellNumber>{count}</UnitsCellNumber>
    <UnitsCellLabel>Units</UnitsCellLabel>
  </UnitsCellContainer>
);
interface MonthForecastCellProps {
  amount: number;
  startDate?: string;
  endDate?: string;
  units: number;
}

const MonthForecastCell = ({
  amount,
  startDate,
  endDate,
  units,
}: MonthForecastCellProps) => {
  const formattedAmount = formatNumberForCurrency(amount) ?? "0";
  return (
    <CellContainer>
      <CellDateRow>
        <CalendarColoredIcon />
        {startDate && endDate ? formatDateRangeShort(startDate, endDate) : ""}
      </CellDateRow>
      <CellAmount>{formattedAmount}</CellAmount>
      <UnitsCell count={units} />
    </CellContainer>
  );
};
const VerticalDivider = styled.div`
  border-right: 1px solid ${BLUE_LIGHT};
  height: 100%;
  margin: 0px 14px;
`;
interface ForecastedSalesSnapshotCardProps {
  data: ForecastedSalesItem[];
}

export default ({ data }: ForecastedSalesSnapshotCardProps) => {
  return (
    <Container>
      <HeaderRow>
        <HeaderTitleCell>
          <HeaderIcon>
            <ForecastedSalesIcon />
          </HeaderIcon>
          <HeaderTitle>Forecasted sales</HeaderTitle>
        </HeaderTitleCell>
        <DateRange>90 day outlook</DateRange>
      </HeaderRow>
      <MonthForecastRow>
        <MonthForecastCell
          amount={data[0]?.value ?? 0}
          units={data[0]?.units?.total ?? 0}
          startDate={data[0]?.time_range?.start}
          endDate={data[0]?.time_range?.end}
        />
        <VerticalDivider />
        <MonthForecastCell
          amount={data[1]?.value ?? 0}
          units={data[1]?.units?.total ?? 0}
          startDate={data[1]?.time_range?.start}
          endDate={data[1]?.time_range?.end}
        />
        <VerticalDivider />
        <MonthForecastCell
          amount={data[2]?.value ?? 0}
          units={data[2]?.units?.total ?? 0}
          startDate={data[2]?.time_range?.start}
          endDate={data[2]?.time_range?.end}
        />
      </MonthForecastRow>
    </Container>
  );
};
